module.exports = __webpack_public_path__ + "img/jx_logo_b.88b7cde0.png";